import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.error('Missing Supabase environment variables');
  console.error('VITE_SUPABASE_URL:', supabaseUrl ? 'Set' : 'Missing');
  console.error('VITE_SUPABASE_ANON_KEY:', supabaseKey ? 'Set' : 'Missing');
}

export const supabase = supabaseUrl && supabaseKey 
  ? createClient(supabaseUrl, supabaseKey)
  : null;

export const sendWelcomeEmail = async (email: string, username: string) => {
  try {
    if (!supabase) {
      console.warn('Supabase client not initialized, cannot send welcome email');
      return false;
    }

    const { error } = await supabase.functions.invoke('send-welcome-email', {
      body: { email, username }
    });
    
    if (error) throw error;
    return true;
  } catch (error) {
    console.error('Error sending welcome email:', error);
    return false;
  }
};